import ModalBindings from '../modal/ModalBindings';
import GroupActions from '../group-actions/group-actions';
import Common from '../../assets/js/common';

export default new class CatalogSearchFilter {
    constructor() {
        this.searchInput = '.js-catalogSearchInput';
        this.searchInputClear = '.js-catalogSearchClear';
        this.searchWrap = '.js-catalogSearchWrap';
        this.searchForm = '.js-catalogSearchForm';
        this.categoriesPopup = '.js-categoriesPopup';
        this.categories = [];
        this.confirmCategoriesBtn = '.js-confirmCategories';
        this.categoriesPopupBtn = '.js-categoriesCount';
        this.filterSelect = 'select.js-catalogFilterSelect';
        this.filterRadio = '.js-catalogSearchRadio';
        this.productOfferCheckbox = '.js-productOfferCheckbox';
        this.checkAllOffersCheckbox = '.js-checkAll';
        this.groupActions = '.js-groupActions';
        this.offersCheckedLength = '.js-offersCheckedLength';
        this.footer = '.footer';
        this.checkedOffersArr = [];
    }

    init() {
        this.bindEvents();
        this.setSelectedCategoriesLength();
        this.setCheckedOffersLength();
    }

    setSelectedCategoriesLength() {
        let categoriesLength = this.categories.length, 
            firstWord = categoriesLength == 1 ? 'Выбрана' : 'Выбрано',
            secondWord = Common.declensionOfNum(categoriesLength, ['категория', 'категории', 'категорий']);

        $(this.categoriesPopupBtn).text(firstWord + ' ' + categoriesLength + ' ' + secondWord);
    }

    bindEvents() {
        $(document).on('input', this.searchInput, (e)=> {
            let value = e.target.value,
                data = $(this.searchForm).serializeArray();

            if (value.length >= 3) {
                this.makeRequest(this.getFiltersParams());
            }
        });
        $(document).on('change', this.filterSelect, () => {
            this.makeRequest(this.getFiltersParams());
        });
        $(document).on('change', this.filterRadio, () => {
            this.makeRequest(this.getFiltersParams());
        });
        $(document).on('click', this.searchInputClear, (e) => {
            $(e.target).closest(this.searchWrap).find(this.searchInput).val('');
        });
        $(document).on('click', this.confirmCategoriesBtn, () => {
            this.saveCategories();
            this.makeRequest(this.getFiltersParams());
        });
        $(document).on('click', this.productOfferCheckbox, (e) => {
            this.toggleCheckAllOffersCheckbox();
            this.toggleGroupActions();
            this.setCheckedOffersLength();
        });
    }

    setCheckedOffersLength() {
        let counter = 0;

        for (var i = 0; i < this.checkedOffersArr.length; i++) {
            if (this.checkedOffersArr[i]) {
                counter++;
            }
        }

        $(this.offersCheckedLength).text(counter);
    }

    /**
     * show/hide group actions block
     */
    toggleGroupActions() {
        this.checkedOffersArr = this.getCheckboxesStatusArr();

        let doesAnyCheckboxesChecked = this.checkedOffersArr.indexOf(true) >= 0 ? true : false,
            $groupItemBlock = $(this.groupActions);

        if (doesAnyCheckboxesChecked) {
            $groupItemBlock.removeClass('_hidden');
        } else {
            $groupItemBlock.addClass('_hidden');
        }
    }

    toggleCheckAllOffersCheckbox() {
        this.checkedOffersArr = this.getCheckboxesStatusArr();
        let $checkAllOffersCheckbox = $(this.checkAllOffersCheckbox);

        if (this.checkedOffersArr.length && this.checkedOffersArr.indexOf(false) < 0) {
            $checkAllOffersCheckbox.prop('checked', true);
        } else {
            $checkAllOffersCheckbox.prop('checked', false);
        }
    }

    getCheckboxesStatusArr() {
        let $offerCheckboxesArr = $(this.productOfferCheckbox);
        this.checkedOffersArr = [];

        for (let i = 0; i < $offerCheckboxesArr.length; i++) {
            this.checkedOffersArr.push($($offerCheckboxesArr[i]).prop('checked'));
        }

        return this.checkedOffersArr;
    }

    getFiltersParams() {
        let params = $(this.searchForm).serializeArray();
        params.push({name: 'categories', value: this.categories});

        return params;
    }

    saveCategories() {
        let checkedCategoriesInputs = $(this.categoriesPopup).find('.checkbox__input:checked ');
        this.categories = [];

        for (var i = 0; i < checkedCategoriesInputs.length; i++) {
            this.categories.push(checkedCategoriesInputs[i].name);
        }
        this.setSelectedCategoriesLength();
        ModalBindings.hideModal();
    }

    makeCategoriesChecked() {
        let categoriesInputs = $(this.categoriesPopup).find('.checkbox__input');

        for (var i = 0; i < categoriesInputs.length; i++) {
            $(categoriesInputs[i]).prop('checked', false);
            for (var j = 0; j < this.categories.length; j++) {
                if ($(categoriesInputs[i]).attr('name') == this.categories[j]) {
                    $(categoriesInputs[i]).prop('checked', true);
                }
            }
        }
    }

    makeRequest(data) {
        let dataToSend = this.reformatData(data);
        dataToSend.checkedOffers = GroupActions.setSelectedOfferIds();
        $.request('OffersList::onAjaxRequest', {
            data: dataToSend,
            update: {'account-catalog-offers-result': '.catalog-offers-list'},
            loading: '.js-catalogPreloader',
            complete: () => {
                this.toggleGroupActions();
                this.toggleCheckAllOffersCheckbox();
            }
        });
    }

    reformatData(data) {
        let resultData = {};

        for (var i = 0; i < data.length; i++) {
            let currentName = data[i].name,
                currentValue = data[i].value;

            resultData[currentName] = currentValue;
        }

        return resultData;
    }
};


// WEBPACK FOOTER //
// ./src/common/modules/catalog-search-filter/catalog-search-filter.js